module.exports = __webpack_public_path__ + "img/header-news.7bff3a24.jpeg";